import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reusable scroll-triggered fade-up reveal. Uses framer-motion's `whileInView`
 * so it fires once when the element scrolls past the threshold.
 * Matches the entrance easing used by the Breww landing hero.
 */
const ScrollReveal = ({
  children,
  delay = 0,
  y = 40,
  duration = 0.7,
  className = '',
  as: Tag = 'div',
}) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default ScrollReveal;
